<template>
  <div class="bg-neutral-900">
    <div class="mx-auto justify-between py-5 text-white md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl desktop:flex">
      <div class="grid grid-cols-2 gap-3 text-center desktop:flex">
        <template v-for="link in links">
          <SharedLink
            v-if="magnoliaGetters.showKioskOrCatalog($flags, link.showLinkKiosk, link.showLinkCatalog)"
            :key="link.name"
            class="border-r border-white pr-3 text-sm last-of-type:border-r-0 mobile:border-r-0 tablet:border-r-0 desktop:max-h-lg desktop:leading-[16px]"
            :link="link"
          >
            {{ link.name }}
          </SharedLink>
        </template>
      </div>
      <div class="mt-6 text-center desktop:mt-0">
        <span data-testid="legal-information__kik-text">{{ $t("© KiK Textiles and Non-Food GmbH {year}", { year: (new Date()).getFullYear() }) }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

interface Props {
  links?: any[];
}

withDefaults(defineProps<Props>(), {
  links: () => [],
});

const { $flags } = useNuxtApp();
</script>
